import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommMoisturizerIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M2.5343 19.0099C2.5343 20.3662 3.63377 21.4657 4.99012 21.4657H19.5785C20.9348 21.4657 22.0343 20.3662 22.0343 19.0099V13.1093C22.0343 12.6951 21.6985 12.3593 21.2843 12.3593H3.2843C2.87009 12.3593 2.5343 12.6951 2.5343 13.1093V19.0099ZM4.99012 19.9657C4.46223 19.9657 4.0343 19.5378 4.0343 19.0099V13.8593H20.5343V19.0099C20.5343 19.5378 20.1064 19.9657 19.5785 19.9657H4.99012Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M10.0665 16.913C10.0665 17.3272 10.4023 17.663 10.8165 17.663H14.1226C14.5368 17.663 14.8726 17.3272 14.8726 16.913 14.8726 16.4988 14.5368 16.163 14.1226 16.163H10.8165C10.4023 16.163 10.0665 16.4988 10.0665 16.913zM4.99036 13.8583C5.40457 13.8583 5.74036 13.5225 5.74036 13.1083V10.2888H18.8287V13.1083C18.8287 13.5225 19.1645 13.8583 19.5787 13.8583 19.9929 13.8583 20.3287 13.5225 20.3287 13.1083V9.53885C20.3287 9.12463 19.9929 8.78885 19.5787 8.78885H4.99036C4.57614 8.78885 4.24036 9.12463 4.24036 9.53885V13.1083C4.24036 13.5225 4.57614 13.8583 4.99036 13.8583z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M6.9572 10.1473C7.37142 10.1473 7.7072 9.8115 7.7072 9.39728V8.47694C7.7072 7.61091 8.40742 6.90787 9.27341 6.90435C9.27339 6.90435 9.27342 6.90435 9.27341 6.90435L9.88471 6.90191C11.4339 6.89564 12.6826 5.75313 12.9089 4.30695C13.8534 4.6415 14.7547 5.09034 15.4671 5.64004C16.4188 6.37441 16.9496 7.21685 16.9496 8.15431V9.39728C16.9496 9.8115 17.2854 10.1473 17.6996 10.1473C18.1139 10.1473 18.4496 9.8115 18.4496 9.39728V8.15431C18.4496 6.57957 17.541 5.34568 16.3834 4.45248C15.2259 3.55931 13.736 2.93487 12.3355 2.55995C12.0927 2.49494 11.8334 2.55591 11.645 2.72235C11.4566 2.88878 11.3641 3.13854 11.3987 3.38754L11.43 3.61322C11.43 3.6132 11.43 3.61324 11.43 3.61322C11.5608 4.55605 10.8305 5.39805 9.87871 5.40192C9.8787 5.40192 9.87872 5.40192 9.87871 5.40192L9.26741 5.40436C7.57537 5.41121 6.2072 6.78482 6.2072 8.47694V9.39728C6.2072 9.8115 6.54299 10.1473 6.9572 10.1473Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
